// Central data: swap these values for the real ones later.
export const CONTACT = {
  email: "schwartz.ramona@web.de",
  phone: "+49 176 21987225",
};


export const GALLERY = [
  {
    url: "/img/gallery/1.jpg",
    tall: true,
  },
  {
    url: "/img/gallery/2.jpg",
    tall: false,
  },
  {
    url: "/img/gallery/3.jpg",
    tall: false,
  },
  {
    url: "/img/gallery/4.jpg",
    tall: true,
  },
  {
    url: "/img/gallery/5.jpg",
    tall: false,
  },
  {
    url: "/img/gallery/6.jpg",
    tall: true,
  },
  {
    url: "/img/gallery/7.jpg",
    tall: false,
  },
  {
    url: "/img/gallery/8.jpg",
    tall: true,
  },
  {
    url: "/img/gallery/9.jpg",
    tall: false,
  },
  {
    url: "/img/gallery/10.jpg",
    tall: true,
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "Der Blick",
    body:
      "Janna besitzt eine für ihr Alter seltene Ruhe – eine stille, wissende Präsenz, die vor der Kamera wunderbar wirkt. Jedes Bild wirkt durchdacht, niemals gestellt.",
  },
  {
    no: "02",
    title: "Die Anmut",
    body:
      "Von Studio-Editorials bis zu weichem Naturlicht bewegt sie sich mit einer Leichtigkeit, die Stylisten und Fotografen frei arbeiten lässt. Lenkbar, geduldig und unendlich neugierig.",
  },
  {
    no: "03",
    title: "Der Weg",
    body:
      "Vertreten für Print, Werbung und Laufsteg. Jede Buchung wird von ihrer Familie mit Sorgfalt koordiniert, damit die Erfahrung freudvoll, professionell und altersgerecht bleibt.",
  },
];
